export default "__VITE_ASSET__CJgJ2K8t__"